module.exports = __webpack_public_path__ + "static/media/icon-rotate.446c79d5.svg";